<template>
  <form id="reset_password" class="signup_form" @submit.prevent="resetPassword">
      <ul>
          <div class="part">
              <li>
                  <label>סיסמא נוכחית</label>
                  <div class="eye" >
                    <div v-if="!showCurrentPassword" @click="showCurrentPassword=!showCurrentPassword">
                        <i class="fas fa-eye"></i>
                    </div>
                    <div v-else @click="showCurrentPassword=!showCurrentPassword">
                        <i class="fas fa-eye-slash"></i>
                    </div>
                    <input :type="showCurrentPassword ? 'text' : 'password'" name="password" required v-model="current_password">
                  </div>
                  <!-- <span class="helper_text">לפחות 8 תווים</span> -->
              </li>
              <li >
                  <label>בחירת סיסמא</label>
                  <div class="eye" >
                    <div v-if="!showPassword" @click="showPassword=!showPassword">
                        <i class="fas fa-eye"></i>
                    </div>
                    <div v-else @click="showPassword=!showPassword">
                        <i class="fas fa-eye-slash"></i>
                    </div>
                    <input :type="showPassword ? 'text' : 'password'" name="password" required v-model="password">
                  </div>
                  <span class="helper_text">לפחות 8 תווים</span>
              </li>
              <li>
                  <label>סיסמא בשנית</label>
                  <input :type="showPassword ? 'text' : 'password'" name="password"  required v-model="repeatPasswortInput">
                  <!-- <span class="helper_text">לפחות 8 תווים</span> -->
              </li>
          </div>
          <input type="submit" class="btn" value="המשך">
      </ul>
    </form>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            current_password: '',
            repeatPasswortInput: '',
            showCurrentPassword: false,
            showPassword:false
        }
    },
    methods: {
        validate() {
              const rgxPswd = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
              if (!rgxPswd.test(this.password)) {
                  return 'הסיסמא חייבת אות ומספר ומינימום 8 תווים'
              }
              if (this.password !== this.repeatPasswortInput) {
                  return 'הסיסמאות לא שוות'
              }
          },
        resetPassword() {
            let error = this.validate();
              if (error) {
                  this.$swal({
                      toast: true, 
                      position: 'bottom-start', 
                      showConfirmButton: false,
                      timer: 3000, 
                      icon: 'error', 
                      title: error 
                  });
                  return false;
              }
            this.api({ action: 'user/reset_password', data: { current_password: this.current_password, new_password: this.password } }, (data) => {
                if (data.data) {
                    this.alert('עודכן בהצלחה');
                    this.current_password = '';
                    this.password = ''
                    this.repeatPasswortInput = ''
                    this.showPassword = false
                    this.showCurrentPassword = false
                } else {
                    this.alert('עדכון נכשל נסה שוב מאוחר יותר');
                }
            });
        }
    }
}
</script>

<style>

</style>